import React, { useContext, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';

import AppContext from '../../../context';
import { ReactComponent as Cross } from '../../../../assets/icons/cross.svg';
import { ReactComponent as DottedCircle } from '../../../../assets/icons/dotted-circle.svg';
import { ReactComponent as MFIcon } from '../../../../assets/icons/mf-icon.svg';
import { ReactComponent as TickCircleGreen } from '../../../../assets/icons/tick-circle-green.svg';
import './sync_broker_or_mf.component.css';

const SyncBrokerMF = (props) => {
  // Context
  const context = useContext(AppContext);
  const { show, setShow, setShowImportMFs, setShowManagePf, setManagePfFrom } =
    props;

  const [brokerMF, setBrokerMF] = useState('broker');
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

  return (
    <Modal
      show={show}
      centered
      className="sync_broker_or_mf__modal"
      onHide={() => setShow(false)}
    >
      <Modal.Body>
        <div className="content_header">
          <h4>Sync Stocks/MFs holdings</h4>
          <button
            type="button"
            className="close_btn"
            onClick={() => setShow(false)}
          >
            <Cross />
          </button>
        </div>
        <div className="content_body">
          <div className="instruments">
            <div className="instrument" onClick={() => setBrokerMF('broker')}>
              <div className="icon_cont">
                <div className="mf_icon">
                  <DottedCircle />
                  <div>
                    <MFIcon />
                  </div>
                </div>
                <div
                  className={`tick_icon ${
                    brokerMF === 'broker' ? '' : 'hidden'
                  }`}
                >
                  <TickCircleGreen />
                </div>
              </div>
              <div className="name">Stocks</div>
            </div>
            <div className="instrument" onClick={() => setBrokerMF('mfs')}>
              <div className="icon_cont">
                <div className="mf_icon">
                  <DottedCircle />
                  <div>
                    <MFIcon />
                  </div>
                </div>
                <div
                  className={`tick_icon ${brokerMF === 'mfs' ? '' : 'hidden'}`}
                >
                  <TickCircleGreen />
                </div>
              </div>
              <div className="name">Mutual Funds</div>
            </div>
          </div>
          <button
            type="button"
            className="continue_btn"
            disabled={isSubmitDisabled}
            onClick={() => {
              if (brokerMF === 'broker') {
                setIsSubmitDisabled(true);
                setManagePfFrom('sync_from_summary');
                setShowManagePf(true);
                return;
              }
              if (brokerMF === 'mfs') {
                setShowImportMFs(true);
                setShow(false);
                return;
              }
            }}
          >
            Continue
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SyncBrokerMF;
